import { User, Plus } from "lucide-react";
import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";
import BioDialog from "@/components/BioDialog";
import { TEAM, ADVISORS } from "@/lib/content";

export default function Team() {
    return (
        <section
            id="team"
            className="relative border-t border-white/10 bg-navy-900"
            data-testid="team"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                <Reveal>
                    <SectionLabel index="09">Team</SectionLabel>
                </Reveal>

                {/* Leadership */}
                <StaggerGroup className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    {TEAM.map((member) => (
                        <StaggerItem key={member.name}>
                            <div className="group border border-white/10 p-8 transition-colors duration-300 hover:border-gold/40">
                                {/* Photo */}
                                <div className="relative mb-6 aspect-square w-full overflow-hidden border border-white/10 bg-navy-800">
                                    {member.img ? (
                                        <img
                                            src={member.img}
                                            alt={member.name}
                                            className="h-full w-full object-cover object-top grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-[1.03]"
                                        />
                                    ) : (
                                        <div className="flex h-full w-full items-center justify-center">
                                            <User
                                                className="h-16 w-16 text-white/15"
                                                strokeWidth={1}
                                            />
                                        </div>
                                    )}
                                </div>
                                <h3 className="font-display text-2xl font-light text-white">
                                    {member.name}
                                </h3>
                                <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-gold">
                                    {member.role}
                                </p>
                                {member.bio && <BioDialog member={member} />}
                            </div>
                        </StaggerItem>
                    ))}
                </StaggerGroup>

                {/* Advisors — hidden for now, re-enable later */}
                {false && (
                <div id="advisors" className="mt-24 scroll-mt-24">
                    <Reveal>
                        <SectionLabel index="09">Pending Advisors</SectionLabel>
                    </Reveal>
                    <StaggerGroup className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
                        {ADVISORS.map((advisor) => (
                            <StaggerItem key={advisor.name}>
                                <div className="group flex items-center gap-4 bg-navy-950 p-6 transition-colors duration-300 hover:bg-navy-800">
                                    <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden border border-white/10 bg-navy-800 transition-colors group-hover:border-gold/40">
                                        {advisor.img ? (
                                            <img
                                                src={advisor.img}
                                                alt={advisor.name}
                                                className="h-full w-full object-cover object-top grayscale transition-all duration-500 group-hover:grayscale-0"
                                            />
                                        ) : (
                                            <User
                                                className="h-5 w-5 text-white/25"
                                                strokeWidth={1.25}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <p className="text-base font-medium text-white">
                                            {advisor.name}
                                        </p>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
                                            Advisor
                                        </p>
                                    </div>
                                </div>
                            </StaggerItem>
                        ))}
                        <StaggerItem>
                            <div className="flex h-full items-center gap-4 bg-gold/[0.04] p-6">
                                <div className="flex h-12 w-12 shrink-0 items-center justify-center border border-gold/40">
                                    <Plus className="h-5 w-5 text-gold" strokeWidth={1.25} />
                                </div>
                                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gold">
                                    More coming soon
                                </p>
                            </div>
                        </StaggerItem>
                    </StaggerGroup>
                </div>
                )}
            </div>
        </section>
    );
}
